import React from "react";
import PropTypes from "prop-types";
import LoadingSkeleton from "components/atoms/LoadingSkeleton/LoadingSkeleton";
import Column from "components/atoms/Column/Column";
import { Card as BootstrapCard } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import "./Card.scss";

interface ICardProps {
  children?: React.ReactNode;
  className?: string | boolean;
  isLoading?: boolean;
  loadingTitle?: string;
  fullHeight?: boolean;
  isDelayed?: boolean;
  id?: string;
  rows?: number;
  style?: object;
  cardStyle?: object;
}

const Card = function ({
  children,
  className,
  isLoading,
  loadingTitle,
  fullHeight,
  isDelayed,
  id,
  rows,
  style,
  cardStyle,
}: ICardProps) {
  const cardClass = fullHeight ? "h-100" : "";

  const delayMessage = (
    <FormattedMessage
      id="components.atoms.info-card.contentLoadingMsg"
      defaultMessage="Content is taking some time to load"
    />
  );

  return (
    <Column className={`pl-0 pr-0 ${className}`} style={style}>
      <BootstrapCard className={`${cardClass}`} id={id} style={cardStyle}>
        {isLoading ? <LoadingSkeleton header={isDelayed ? delayMessage : loadingTitle} rows={rows} /> : children}
      </BootstrapCard>
    </Column>
  );
};

Card.Header = BootstrapCard.Header;
Card.Footer = BootstrapCard.Footer;
Card.Text = BootstrapCard.Text;
Card.Body = BootstrapCard.Body;
Card.Title = BootstrapCard.Title;

Card.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  loadingTitle: PropTypes.string,
  fullHeight: PropTypes.bool,
  isDelayed: PropTypes.bool,
  id: PropTypes.string,
  rows: PropTypes.number,
  style: PropTypes.instanceOf(Object),
  cardStyle: PropTypes.instanceOf(Object),
};

Card.defaultProps = {
  className: null,
  isLoading: false,
  loadingTitle: null,
  fullHeight: false,
  isDelayed: false,
  id: null,
  children: null,
  rows: 1,
  style: {},
  cardStyle: {},
};

export default Card;
